export default __webpack_public_path__ + "static/CenturyExpanded-Bold-9b53b3f03414a51e2601cca2d2adb0ca.woff2";